import React from "react";

const LoansContent = () => {
  return (
    <div className="my-16 mx-16 py-10 rounded-2xl text-center border">
      <div>
        <h3 className="mb-8 text-themeColor">
          Can you get a loans in Thailand
        </h3>
      </div>
      <div
        className="my-20 text-medium font-medium"
        style={{ paddingLeft: "30px", paddingRight: "30px" }}
      >
        <p className="my-8">
          Investing in real estate in Thailand just got easier with the option
          of obtaining a loan. Whether you're a Thai citizen or a foreign
          national, you can now qualify for a mortgage and finance your dream
          property. With a variety of loan options available, you can choose the
          one that best fits your needs and budget. From fixed-rate mortgages to
          adjustable-rate loans, you can find a loan that works for you. Our
          experienced team can assist you in navigating the loan process, from
          pre-approval to closing, and help you find the perfect property to fit
          your needs. Contact us today to learn more about obtaining a loan in
          Thailand and take the first step towards owning your dream property.
        </p>
      </div>
    </div>
  );
};

export default LoansContent;
